export function adaptRawHtmlBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  return {
    html: (entry['html'] as string) ?? '',
  };
}
